export function getDatePart(dateString: string): string {
	return dateString.split('T')[0];
}

